import {Injectable} from "@angular/core";
import {ServerService} from "../../services/ServerService";
import {HttpClient} from "@angular/common/http";
import {FiltroPedidoUltis} from "../../services/FiltroPedidoUltis";
import {EnumFiltroDePedidos} from "../../services/pedidos.service";
import {IOperacoesModuloPedidos} from "./ioperacoesmodulopedidos";

@Injectable({
  providedIn: 'root'
})
export class GrupolojasService extends  ServerService implements IOperacoesModuloPedidos{
  constructor(http: HttpClient) {
    super(http)
  }

  logado(){
    return this.obtenha('/api/grupolojas/me' , {});
  }

  private paramsCentralPedidos(grupoDeLojasId?: number) {
    return grupoDeLojasId ? { grupoDeLojasId } : {};
  }

  private dadosCentralPedidos(dados: any = {}, grupoDeLojasId?: number) {
    return grupoDeLojasId ? { ...dados, grupoDeLojasId } : dados;
  }

  obtenhaCentralPedidos(grupoDeLojasId?: number){
    return this.obtenha('/grupolojas/central-pedidos/me' , this.paramsCentralPedidos(grupoDeLojasId));
  }

  fecheCentralPedidos(dados: any = {}, grupoDeLojasId?: number) {
    return this.facaPost('/grupolojas/central-pedidos/fechar', this.dadosCentralPedidos(dados, grupoDeLojasId));
  }

  reabraCentralPedidos(grupoDeLojasId?: number) {
    return this.facaPost('/grupolojas/central-pedidos/abrir', this.dadosCentralPedidos({}, grupoDeLojasId));
  }

  salveHorariosCentralPedidos(dados: any, grupoDeLojasId?: number) {
    return this.facaPut('/grupolojas/central-pedidos/horarios', this.dadosCentralPedidos(dados, grupoDeLojasId));
  }

  crieClienteCentralPedidos(dados: any, grupoDeLojasId?: number){
    return this.facaPost('/grupolojas/central-pedidos/clientes', this.dadosCentralPedidos(dados, grupoDeLojasId));
  }

  busqueClientesCentralPedidos(q: string, grupoDeLojasId?: number){
    return this.obtenha('/grupolojas/central-pedidos/clientes' , { q, ...this.paramsCentralPedidos(grupoDeLojasId) });
  }

  selecioneClienteCentralPedidos(empresaId: number, contatoId: number, grupoDeLojasId?: number){
    return this.facaPost(`/grupolojas/central-pedidos/clientes/${empresaId}/${contatoId}/selecionar`, this.dadosCentralPedidos({}, grupoDeLojasId));
  }

  selecioneEnderecoCentralPedidos(empresaId: number, contatoId: number, enderecoId: number, grupoDeLojasId?: number){
    return this.facaPost(`/grupolojas/central-pedidos/clientes/${empresaId}/${contatoId}/enderecos/${enderecoId}/selecionar`, this.dadosCentralPedidos({}, grupoDeLojasId));
  }

  roteieLojaCentralPedidos(empresaId: number, contatoId: number, enderecoId: number, grupoDeLojasId?: number){
    return this.facaPost('/grupolojas/central-pedidos/rotear-loja', this.dadosCentralPedidos({ empresaId, contatoId, enderecoId }, grupoDeLojasId));
  }

  carregueCardapioCentralPedidos(empresaId: number, grupoDeLojasId?: number){
    return this.obtenha(`/grupolojas/central-pedidos/lojas/${empresaId}/cardapio`, this.paramsCentralPedidos(grupoDeLojasId));
  }

  prepareAtendimentoV3CentralPedidos(dados: any, grupoDeLojasId?: number){
    return this.facaPost('/grupolojas/central-pedidos/preparar-atendimento-v3', this.dadosCentralPedidos(dados, grupoDeLojasId));
  }

  prepareLojaV3CentralPedidos(dados: any, grupoDeLojasId?: number){
    return this.facaPost('/grupolojas/central-pedidos/preparar-loja-v3', this.dadosCentralPedidos(dados, grupoDeLojasId));
  }

  prepareAtendimentoInterlojaCentralPedidos(dados: any, grupoDeLojasId?: number){
    return this.facaPost(
      '/grupolojas/central-pedidos/preparar-atendimento-interloja',
      this.dadosCentralPedidos(dados, grupoDeLojasId)
    );
  }

  listeFormasPagamentoPresenciaisCentralPedidos(empresaId: number, grupoDeLojasId?: number){
    return this.obtenha(
      `/grupolojas/central-pedidos/lojas/${empresaId}/formas-pagamento-presenciais`,
      this.paramsCentralPedidos(grupoDeLojasId)
    );
  }

  criePedidoInterlojaCentralPedidos(dados: any, grupoDeLojasId?: number){
    return this.facaPost(
      '/grupolojas/central-pedidos/pedidos-interloja',
      this.dadosCentralPedidos(dados, grupoDeLojasId)
    );
  }

  listePedidos(inicio: number, total: number, filtro: any = {},
               filtroPedido: EnumFiltroDePedidos = EnumFiltroDePedidos.todos){

    let dados: any = FiltroPedidoUltis.obtenhaDados(inicio, total, filtro, filtroPedido);

    return this.obtenha('/grupolojas/pedidos', dados);
  }

  listePedidosCancelados(inicio: number, total: number, contato: any = null,  dtInicio: string = null, dtFim: string= null,
                         filtro: EnumFiltroDePedidos = EnumFiltroDePedidos.todos, q: string){
    let dados: any = { i: inicio, t: total, cancelados: true};

    if(contato) dados.cid = contato.id;
    if(dtInicio) dados.di = dtInicio;
    if(dtFim) dados.df = dtFim;
    dados.q = q;
    dados.f = filtro;

    return this.obtenha('/grupolojas/pedidos', dados);
  }

  obtenhaPorCodigo(codigo: any, idEmpresa: any) {
    return this.obtenha(String(`/grupolojas/pedidos/chave/${idEmpresa}/${codigo}`), {})
  }

  localizePedidosPorCodigo(codigo: any) {
    return this.obtenha(`/grupolojas/pedidos/codigo/${codigo}`, {});
  }

  foiVisualizado(pedido: any, idEmpresa: any){
    return this.salve(String(`/grupolojas/pedidos/visualizado/${idEmpresa}/${pedido.id}`), pedido)
  }

  marqueFoiImpresso(pedido: any, idEmpresa: any = null, impressaoAutomatica: boolean = false,
                    impressora: any = null){
    const empresaId = idEmpresa || pedido?.empresa?.id;
    const dados: any = { impressaoAutomatica: impressaoAutomatica };
    if(impressora && impressora.id)
      dados.impressoraId = impressora.id;

    return this.facaPut(`/grupolojas/pedidos/${empresaId}/${pedido.guid}/impresso`, dados)
  }

  obtenhaPorGuid(codigo: any,  idEmpresa: any ) {
    return this.obtenha(String(`/grupolojas/pedidos/chave/${idEmpresa}/${codigo}`), {  });
  }


  listeUltimoPedidosAtras(tempo: number, origens = []){
    return this.obtenha('/grupolojas/pedidos/ultimo/' + tempo, { o: origens.join(',')});
  }

  async sincronizePagamentoOnline(pedido: any) {
    let pagamentoOnline = pedido.pagamentos.find((item: any) => item.formaDePagamento.online);

    if(!pagamentoOnline) return Promise.resolve(null);

    return this.obtenha(`/grupolojas/pedidos/pagamento/${pedido.empresa.id}/${pedido.guid}/${pagamentoOnline.id}/sincronize/${pagamentoOnline.statusNumero}`, {})
  }

  listeStatusIfood(){
    return this.http.get('/grupolojas/integracoes/ifood/lojas/status', {}).toPromise();
  }

  executePollingIfood(){
    return this.http.get('/grupolojas/integracoes/ifood/events/polling/dispare', {}).toPromise();
  }

  listeStatus99Food(){
    return this.http.get('/grupolojas/integracoes/99food/lojas/status', {}).toPromise();
  }

  listeStatusKeeta(){
    return this.http.get('/grupolojas/integracoes/keeta/lojas/status', {}).toPromise();
  }

  listeStatusOpenDelivery(){
    return this.http.get('/grupolojas/integracoes/opendelivery/lojas/status', {}).toPromise();
  }

  listeFalhasImportacao(inicio = 0, total = 25){
    return this.obtenha('/grupolojas/pedidos/importacao/falhas', { i: inicio, t: total });
  }

  marqueFalhaImportacaoLida(falhaIntegracao: any){
    return this.facaPut('/grupolojas/pedidos/importacao/falhas/' + falhaIntegracao.id + '/lida', falhaIntegracao);
  }

  listeEntregadores(idEmpresa: any, nome: any = null) {
    const params: any = {};
    if(nome) params.nome = nome;

    return this.obtenha(`/grupolojas/entregadores/${idEmpresa}`, params);
  }

  async sincronizePedidoKeeta(pedido: any){
    return this.facaPost(`/grupolojas/integracoes/keeta/pedido/${pedido.empresa.id}/${pedido.guid}/sincronize`, {})
  }

  async sincronizePedido99Food(pedido: any){
    return this.facaPost(`/grupolojas/integracoes/99food/pedido/${pedido.empresa.id}/${pedido.guid}/sincronize`, {})
  }

  async sincronizePedidoOpenDelivery(pedido: any){
    return this.facaPost(`/grupolojas/integracoes/opendelivery/pedido/${pedido.empresa.id}/${pedido.guid}/sincronize`, {})
  }

  obtenhaStatusCancelamento(pedido: any, idEvent: any){
    return this.obtenha(`/grupolojas/pedidos/cancelamento/status/${pedido.empresa.id}/${pedido.guid}/${idEvent}`, {})
  }

  obtenhaStatusCancelamentoDelivery(pedido: any, idEvent: any){
    return this.obtenha(`/grupolojas/pedidos/cancelamento/status/${pedido.empresa.id}/${pedido.guid}/${idEvent}`, {de: 1})
  }

  finalizeDisputaComAceitar(pedido: any){
    return this.salve(String(`/grupolojas/pedidos/disputa/${pedido.empresa.id}/${pedido.guid}/aceitar`), {id: pedido.id })
  }

  finalizeDisputaComRejeitar(pedido: any, motivo: string, razaoRejeitar: any = {}){
    return this.salve(String(`/grupolojas/pedidos/disputa/${pedido.empresa.id}/${pedido.guid}/rejeitar`),
      {id: pedido.id , motivo: motivo, razao: razaoRejeitar})
  }

  enviePropostaDisputa(pedido: any, acao: any, valor: number){
    return this.salve(String(`/grupolojas/pedidos/disputa/${pedido.empresa.id}/${pedido.guid}/proposta`),
      {id: pedido.id , acao: acao, valor: valor})
  }

  envieRespostaAlteracaoEndereco(pedido: any, aceitou: boolean){
    return this.facaPost(String(`/grupolojas/pedidos/alteracao-endereco/${pedido.empresa.id}/${pedido.guid}/resposta`),
      {aceitou: aceitou ? 1 : 0});
  }

  listeEventosPedido(pedido: any) {
    return this.obtenha(String(`/grupolojas/pedidos/delivery/events/${pedido.empresa.id}/${pedido.guid}`), {});
  }

  obtenhaOrigemPedidoOpenDelivery(pedido: any) {
    return this.obtenha(`/grupolojas/integracoes/opendelivery/pedido/${pedido.empresa.id}/${pedido.guid}/origem`, {});
  }

  listeNotificacoesPedidoOpenDelivery(pedido: any) {
    return this.obtenha(`/grupolojas/integracoes/opendelivery/pedido/${pedido.empresa.id}/${pedido.guid}/notificacoes`, {});
  }

  listeNotificacaoesLogiscaDoPedido(pedido: any) {
    return this.obtenha(String(`/grupolojas/pedidos/delivery/notificacoes/${pedido.empresa.id}/${pedido.id}/opendelivery`), {});
  }

  listeNotificacaoesUberDoPedido(pedido: any) {
    return this.obtenha(String(`/grupolojas/pedidos/delivery/notificacoes/${pedido.empresa.id}/${pedido.id}/uber`), {});
  }

  listeNotificacaoesIfoodDelivery(pedido: any){
    return this.obtenha(String(`/grupolojas/pedidos/delivery/notificacoes/${pedido.empresa.id}/${pedido.id}/ifood`), {});
  }

  listeNotificacaoesFoodydelivery(pedido: any) {
    return this.obtenha(String(`/grupolojas/pedidos/delivery/notificacoes/${pedido.empresa.id}/${pedido.id}/foodydelivery`), {});
  }

  soliciteParceiroOpenDelivery(pedido: any) {
    return this.facaPost(String(`/grupolojas/pedidos/delivery/opendelivery/${pedido.empresa.id}/${pedido.guid}/novaEntrega`), {});
  }

  soliciteFoodDelivery(pedido: any) {
    return this.facaPost(String(`/grupolojas/pedidos/delivery/foodydelivery/${pedido.empresa.id}/${pedido.guid}/novaEntrega`), {});
  }

  soliciteEntregadorIfood(pedido:  any, idLoja: any){
    return this.facaPost(String(`/grupolojas/pedidos/delivery/ifood/${pedido.empresa.id}/${pedido.guid}/novaEntrega`), {idLoja: idLoja});
  }

  canceleCotacaoDeliveryIfood(pedido: any){
    return this.facaPost(String(`/grupolojas/pedidos/delivery/ifood/${pedido.empresa.id}/${pedido.guid}/canceleCotacao`), { });
  }

  soliciteCotacaoIfood(pedido:  any, idLoja: any){
    return this.facaPost(String(`/grupolojas/pedidos/delivery/ifood/${pedido.empresa.id}/${pedido.guid}/novaCotacao`), {idLoja: idLoja});
  }

  soliciteUberDirect(pedido: any, acaoRetorno: any) {
    let descartar = acaoRetorno && acaoRetorno.id === 2;

    return this.facaPost(String(`/grupolojas/pedidos/delivery/uber/${pedido.empresa.id}/${pedido.guid}/novaEntrega`), { descartar: descartar});
  }

  sincronizeEntrega(pedido: any){
    return this.obtenha(String(`/grupolojas/pedidos/delivery/${pedido.delivery.origem}/${pedido.empresa.id}/${pedido.guid}/sincronize`), {})
  }

  canceleEntrega(pedido: any, dados = {}){
    return this.facaPost(String(`/grupolojas/pedidos/delivery/${pedido.delivery.origem}/${pedido.empresa.id}/${pedido.guid}/cancele`), dados)
  }

  verDelivery(pedido: any){
    if(pedido.delivery.origem === 'uber'){
      window.open(String(`/uberdirect/delivery/${pedido.delivery.codigo}`))
    } else  if(pedido.delivery.origem === 'foodydelivery'){
      window.open(String(`/integracaoerp/foodydelivery/${pedido.guid}`))
    }  else     if(pedido.delivery.origem === 'ifood'){
      window.open(String(`/ifood/${pedido.idLojaExterna}/order/${pedido.referenciaExterna}`))
    } else {
      window.open(String(`/opendelivery/delivery/${pedido.guid}`))
    }
  }

  altereEntregador(pedido: any, entregador: any) {
    let params: any = { guid: pedido.guid, entregador: entregador};

    return this.facaPut(`/grupolojas/pedidos/entregador/${pedido.empresa.id}/${pedido.id}`, params)
  }


  altereStatus(pedido: any, status: any, notificar: boolean){
    let params: any = { id: pedido.id, status: status};

    if(notificar) params.notificar = true;

    return this.salve(String(`/grupolojas/pedidos/status/${pedido.empresa.id}/${pedido.id}`), params)
  }

  aceitePedido(pedido: any){
    return this.salve(String(`/grupolojas/pedidos/${pedido.empresa.id}/${pedido.guid}/aceitar`), pedido)
  }

  rejeitePedido(pedido: any, motivo: any = {}){
    return this.salve(String(`/grupolojas/pedidos/${pedido.empresa.id}/${pedido.guid}/rejeitar`), {id: pedido.id, motivo: motivo || {}})
  }

  obtenhaRazoesCancelamentoIfood(pedido: any){
    if(!pedido || !pedido.referenciaExterna) return Promise.resolve([])

    return this.obtenha(String(`/grupolojas/pedidos/cancelamento/ifood/razoes/${pedido.empresa.id}/${pedido.guid}`), {})
  }

  obtenhaRazoesCancelamento99Food(pedido: any){
    if(!pedido || !pedido.referenciaExterna) return Promise.resolve([])

    return this.obtenha(String(`/grupolojas/pedidos/cancelamento/99food/razoes/${pedido.empresa.id}/${pedido.guid}`), {})
  }

  cancelePedido(pedido: any, motivo: any, notificar: boolean){
    let params: any = { guid: pedido.guid, motivo: motivo};

    if(notificar) params.notificar = true;

    return this.facaPut(String(`/grupolojas/pedidos/cancele/${pedido.empresa.id}/${pedido.id}`), params)
  }

  altereFoiPago(pedido: any, foiPago: boolean, formaDePagamento: any){
    return this.salve(String(`/grupolojas/pedidos/pago/${pedido.empresa.id}/${pedido.id}`),
      { id: pedido.id, pago: foiPago, formaDePagamento: formaDePagamento})
  }

  notifiqueSistemaIntegrado(pedido: any){
    return this.facaPost(String(`/grupolojas/pedidos/integracao/notifique/${pedido.empresa.id}/${pedido.id}`), { id: pedido.id});
  }


}
